import { useCartContext } from "app/providers/CartProvider";
import CheckoutNoProducts from "entities/checkout/no-products";
import Card from "shared/ui/card";
import CheckoutDoorList from "widgets/checkout/door-list";
import CheckoutDoorListHeader from "widgets/checkout/door-list-header";
import StandardProductListHeader from "../standard-product-list-header";
import StandardProductList from "../standard-product-list";
import Heading from "shared/ui/typography/Heading";

const CheckoutProducts = () => {
  const checkoutCart = useCartContext().cart;

  return (
    <Card
      className="gg-border-b gg-border-t gg-pt-6 lg:gg-px-8 lg:gg-py-9 xl:gg-px-32"
      shadow={false}
    >
      <Heading
        headingLevel="h2"
        className="gg-mb-6 gg-px-3.5 gg-text-2xl sm:gg-px-8 lg:gg-px-0"
      >
        Winkelwagen
      </Heading>

      {checkoutCart.products.length ? (
        <CheckoutDoorListHeader />
      ) : checkoutCart.standardProducts.length ? (
        <StandardProductListHeader />
      ) : (
        <CheckoutNoProducts />
      )}

      {checkoutCart.products.length ? (
        <CheckoutDoorList products={checkoutCart.products} />
      ) : (
        <></>
      )}
      {checkoutCart.standardProducts.length ? <StandardProductList /> : <></>}
    </Card>
  );
};
export default CheckoutProducts;
